import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  stateDraft: 'Schiță',
  statePending: 'În examinare',
  stateApproved: 'Aprobată',
  stateConcluded: 'Finalizată',
  stateValidated: 'Validată',
  stateArchived: 'Arhivată',
  stateRejected: 'Respinsă',
  stateWithdrawn: 'Retrasă',
  stateCancelled: 'Anulată',
  stateDeleted: 'Ștearsă',
  englishVersion: 'Versiunea în engleză',
  loading: 'Se încarcă…',
  cancel: 'Anulează',
  goBack: 'Înapoi',
  delete: 'Șterge',
  confirmTitle: 'Confirmați acțiunea',
  confirmDeleteTitle: 'Confirmați ștergerea',
  breadcrumbAria: 'Fir de ariadnă',
  accountActive: 'Cont activ',
  accessDenied: 'Nu aveți dreptul de acces la această secțiune.',
  notFound: 'Pagina nu a fost găsită',
} as const;

const en = {
  stateDraft: 'Draft',
  statePending: 'Pending',
  stateApproved: 'Approved',
  stateConcluded: 'Concluded',
  stateValidated: 'Validated',
  stateArchived: 'Archived',
  stateRejected: 'Rejected',
  stateWithdrawn: 'Withdrawn',
  stateCancelled: 'Cancelled',
  stateDeleted: 'Deleted',
  englishVersion: 'English version',
  loading: 'Loading…',
  cancel: 'Cancel',
  goBack: 'Back',
  delete: 'Delete',
  confirmTitle: 'Confirm the action',
  confirmDeleteTitle: 'Confirm the deletion',
  breadcrumbAria: 'Breadcrumb',
  accountActive: 'Active account',
  accessDenied: 'You do not have access to this section.',
  notFound: 'Page not found',
} satisfies Translation<keyof typeof ro>;

export const common = { ro, en } satisfies Dictionary;

export type CommonKey = keyof typeof ro;
